import { ObserverLike, PartialObserver, lift } from './observer';
import { Subscription } from './subscription';

export class SafeSubscriber<T> {
  private observer: PartialObserver<T>;
  closed = false;

  constructor(
    observer: ObserverLike<T>,
    private subscription: Subscription
  ) {
    this.observer = lift(observer);
  }

  next(value: T) {
    if (!this.closed) {
      try {
        this.observer.next?.(value);
      } catch (e) {
        this.error(e);
      }
    }
  }

  complete() {
    if (!this.closed) {
      this.closed = true;
      this.observer.complete?.();
      this.subscription.unsubscribe();
    }
  }

  error(err: unknown) {
    if (!this.closed) {
      this.closed = true;
      this.observer.error?.(err);
      this.subscription.unsubscribe();
    }
  }
}
